import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19.933 13.041a8 8 0 1 1 -9.925 -8.788c3.899 -1 7.935 1.007 9.425 4.747","key":"svg-0"}],["path",{"d":"M20 4v5h-5","key":"svg-1"}]]

/**
 * IconReload
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcmVsb2FkIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xOS45MzMgMTMuMDQxYTggOCAwIDEgMSAtOS45MjUgLTguNzg4YzMuODk5IC0xIDcuOTM1IDEuMDA3IDkuNDI1IDQuNzQ3IiAvPgogIDxwYXRoIGQ9Ik0yMCA0djVoLTUiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/reload
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconReload = createReactComponent('outline', 'reload', 'Reload', __iconNode);

export default IconReload;